<template>
  <div class="claude-container">
    <!-- Search and Action Section -->
    <div style="display: flex; margin-bottom: 20px;">
      <el-button type="primary" size="small" @click="dialogVisible = true">新增API Key</el-button>
      <!-- 搜索栏 -->
      <el-input
          v-model="searchKey"
          placeholder="请输入密钥搜索"
          style="width: 200px; margin-left: 10px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchApiKey"></el-button>
      </el-input>
      <el-dialog title="新增API Key" :visible.sync="dialogVisible" width="30%" @close="resetForm">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="类型" prop="type" :rules="{ required: true, message: '类型不能为空', trigger: 'change' }">
            <el-select v-model="form.type" placeholder="请选择类型">
              <el-option label="办公" :value="0"></el-option>
              <el-option label="酒馆" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可用天数" prop="dailyQuota" :rules="{ required: true, validator: validateDailyQuota, trigger: 'blur' }">
            <el-input v-model.number="form.dailyQuota" type="number"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('form')">确定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- Table Section -->
    <el-table :data="apiKeys" border style="width: 100%">
      <el-table-column type="index" label="序号" width="45"></el-table-column>
      <el-table-column prop="secretKey" label="Secret Key" width="300">
        <template slot-scope="scope">
          {{ scope.row.secretKey }}
          <el-button
              type="text"
              size="mini"
              @click="copySecretKey(scope.row.secretKey)"
              @touchstart="copySecretKey(scope.row.secretKey)">
            复制
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="45">
        <template slot-scope="scope">
          {{ scope.row.type === 0 ? '办公' : '酒馆' }}
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否激活" width="70">
        <template slot-scope="scope">
          {{ scope.row.isActive === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column prop="dailyQuota" label="可用天数" width="70"></el-table-column>
      <el-table-column prop="expiryDate" label="到期日期" width="100"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteApiKey(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import { Message } from 'element-ui';

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        type: '',
        dailyQuota: '',
        expiryDate: ''
      },
      apiKeys: [],
      searchKey: ''
    };
  },
  methods: {
    async fetchApiKeys() {
      try {
        const response = await axios.get('/api/key/list');
        this.apiKeys = response.data.data;
      } catch (error) {
        Message.error('Error fetching API keys: ' + error.message);
      }
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    validateDailyQuota(rule, value, callback) {
      if (value === '') {
        callback(new Error('每日配额不能为空'));
      } else if (!Number.isInteger(value) || value <= 0) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            await axios.post('/api/key/add', this.form);
            this.dialogVisible = false;
            this.$message({
              type: 'success',
              message: 'API Key添加成功'
            });
            await this.fetchApiKeys();
          } catch (error) {
            this.$message.error('添加API Key时发生错误: ' + error.message);
          }
        } else {
          return false;
        }
      });
    },
    async deleteApiKey(id) {
      try {
        await axios.delete(`/api/key/${id}`);
        this.$message({
          type: 'success',
          message: 'API Key删除成功'
        });
        await this.fetchApiKeys();
      } catch (error) {
        this.$message.error('删除API Key时发生错误: ' + error.message);
      }
    },
    copySecretKey(secretKey) {
      if (navigator.clipboard && window.isSecureContext) {
        // 对于支持 navigator.clipboard 的现代浏览器
        navigator.clipboard.writeText(secretKey).then(() => {
          this.$message({
            type: 'success',
            message: 'Secret Key已复制到剪贴板'
          });
        }).catch(err => {
          console.error('Could not copy text: ', err);
          this.$message.error('复制失败');
        });
      } else {
        // 回退方法，适用于不支持 navigator.clipboard 的浏览器
        let textArea = document.createElement("textarea");
        textArea.value = secretKey;
        // 使 textArea 不可见
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          let successful = document.execCommand('copy');
          if (successful) {
            this.$message({
              type: 'success',
              message: 'Secret Key已复制到剪贴板'
            });
          } else {
            this.$message.error('复制失败');
          }
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
          this.$message.error('复制失败');
        }

        document.body.removeChild(textArea);
      }
    },
    async searchApiKey() {
      if (!this.searchKey) {
        this.$message.warning('请输入要搜索的密钥');
        return;
      }
      try {
        const response = await axios.post('/api/key/one', null, {
          params: { serkey: this.searchKey }
        });
        if (response.data.code === 200) {
          this.apiKeys = [response.data.data];
        } else {
          this.$message.error(response.data.msg);
        }
      } catch (error) {
        this.$message.error('搜索API Key时发生错误: ' + error.message);
      }
    }
  },
  mounted() {
    this.fetchApiKeys();
  }
}
</script>

<style scoped>
.claude-container .el-table th {
  background-color: #f5f7fa;
}
.claude-container /deep/ .el-table td, .claude-container /deep/ .el-table th {
  padding: 8px 0;
}
.claude-container /deep/ .el-table .cell {
  line-height: 30px;
}
</style>
